import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { KeycloakService } from 'keycloak-angular';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { ProgressBarModule } from 'primeng/progressbar';
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { of } from 'rxjs';
import { DataStateEnum } from 'src/app/enumeration/dataState.enum';
import { OptionResponseDto } from 'src/app/models/OptionResponseDto';
import { renewOption } from 'src/app/models/renwewOption';
import { collabService } from 'src/app/services/collab/collabService.service';
import { OptionServices } from 'src/app/services/options/option.service';
import { shareOpeSevices } from 'src/app/services/sharedservices/shareOpe.services';
import Keycloak from 'keycloak-js';

@Component({
  selector: 'app-page-options',
  templateUrl: './page-options.component.html',
  imports: [ProgressBarModule, CommonModule, TableModule, ToastModule, ButtonModule, FormsModule],
  styleUrls: ['./page-options.component.scss'],
  providers: [MessageService, OptionServices]

})
export class PageOptionsComponent implements OnInit {


  options!: OptionResponseDto[];
  userRole!: string[];
  usermail!: string | undefined;
  isDiseable: boolean = false;
  renewoption: renewOption = {
    "resi_idoption": "",
    "resi_source": "",
    "resi_statutlotcode": 0,
    "resi_reconduction": 1
  }
  collabNumPrimpromo!: string;
  constructor(private optionService: OptionServices, private collab: collabService, public share: shareOpeSevices, public messageService: MessageService, private keycloakservice: KeycloakService) { }

  ngOnInit() {

    this.keycloakservice.loadUserProfile().then(

      profile => {
        let username = profile.username;
        this.collab.getCollabByEmail(username).subscribe(data => {
          this.userRole = [(data?.profil == "1") ? "admin" : ((data?.profil == "2") ? "interne" : "externe")];
          this.optionService.getOptionByVendeur(data.numPrimpromo).subscribe((data) => {
            this.options = data;
          });
        })
      });


    /*
    this.share.userProfilshared$.subscribe(data=>{

    
         this.userRole = data?.role;
         this.usermail=data?.mail;

         this.collab.getCollabByEmail(this.usermail).subscribe(data=>{
         
          // this.collabNumPrimpromo = data.numPrimpromo;

          this.optionService.getOptionByVendeur( data.numPrimpromo ).subscribe((data) => {
            this.options = data;
        });
    
          
        })
     
  

    })*/


  }
  prolongerOption(optionencours: OptionResponseDto, event: any) {

    event.target.disabled = true;
    this.renewoption.resi_idoption = optionencours.resiIdoption ?? '';
    this.share.showprogressbar = true;

    if (optionencours.resiStatutlotcode === 852810001) {
      this.isDiseable = true;
    }
    this.optionService.postProlongationOption(this.renewoption).subscribe({

      next: (CreateReponseType: any) => {


        if (CreateReponseType.CreateReponseType
          .returnMessage === 'ok') {
          this.share.showprogressbar = true;

          this.messageService.add({ severity: 'success', detail: "Votre prolongation est bien prise en compte" });

          // this.optionService.getOptionEnCoursLot(this.programme.numOpeExt, this.bienselectionee.numBiExt).subscribe({

          //   next: data => {

          //     // this.contactOption = data.nom + ' '+data.prenom;
          //     // this.vendeurOption = data.vendeur;
          //     // this.datefinoptiondisplay = data.resiDateliberationreelle;
          //     this.
          //   },error: (err) => of({ dataStatut: DataStateEnum.ERROR, errorMessage: err.error.message })})
          // this.share.showprogressbar = false;
          // this.isDiseable = true;

          let username = this.keycloakservice.getUsername();

          this.collab.getCollabByEmail(username).subscribe(data => {



            this.optionService.getOptionByVendeur(data.numPrimpromo).subscribe((data) => {
              this.options = data;
            });


          })


          /*this.share.userProfilshared$.subscribe(data=>{
  
           
               this.userRole = data?.role;
               this.usermail=data?.mail;
      
               this.collab.getCollabByEmail(this.usermail).subscribe(data=>{
               
                // this.collabNumPrimpromo = data.numPrimpromo;
      
                this.optionService.getOptionByVendeur( data.numPrimpromo ).subscribe((data) => {
                  this.options = data;
              });
          
                
              })
           
        
      
          })*/

          //   this.optionService.getOptionByVendeur("10772").subscribe((data) => {
          //     this.options = data;
          // });
          this.share.showprogressbar = false;

        }
        else {

          this.messageService.add({ severity: 'warn', detail: "Votre prolongation n'est pas prise en compte" });
          this.share.showprogressbar = false;

        }

      }, error: (err) => of({ dataStatut: DataStateEnum.ERROR, errorMessage: err.error.message })

    })
  }


  isDisabled(option: any): boolean {
    return !((this.hasRole('externe') || this.hasRole('admin')) && option.resiStatutlotcode == '852810004');
  }


  hasRole(role: string): boolean {
    if (this.userRole && this.userRole.length > 0) {
      return this.userRole.includes(role);
    }
    return false;
  }


}


